module.exports = __webpack_public_path__ + "static/img/wow-no-data.6102bd3c.png";